/* fc-pp-story.js (2026-10-12 speed pass): colour-set (or model-set) scene images, the Galaxy/iPhone Duo outline switch and the scroll-snapping scenes.
   Moved out of sections/fc-pp-story.liquid so browsers cache it across product
   pages; the root is #fc-pp-story and per-instance values travel as data
   attributes (or the JSON config script). The bodies are the former inline
   scripts, unchanged apart from those lookups. Re-initialises on
   shopify:section:load for the theme editor. */
(function () {
  'use strict';
  // The buy box's real landing variant (2026-10-24). fc-pp-info lands on its preferred
  // model (and moves on for local stock) rather than on
  // product.selected_or_first_available_variant; the section's Liquid mirrors only the
  // preferred-model rule, so at init the form's variant id is the truth. The map
  // (variant id -> {k: colour-set key, d: device}) comes from the section.
  function fcStoryLanding(root) {
    var el = root.querySelector('[data-fc-story-variants]');
    if (!el) return null;
    var map;
    try { map = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!map) return null;
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[data-fc-form]'));
    for (var i = 0; i < forms.length; i++) {
      var idEl = forms[i].querySelector('[data-fc-variant-id]') || forms[i].querySelector('[name="id"]');
      var id = idEl && idEl.value;
      if (id && map[id]) return map[id];
    }
    return null;
  }
  function initColorSets(root) {

  var cfgEl = root.querySelector('[data-fc-story-media]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.lists) return;
  var imgs = Array.prototype.slice.call(root.querySelectorAll('img[data-fc-story-img]'));
  if (!imgs.length) return;
  var current = root.getAttribute('data-fc-init-color');
  var pending = 0;

  function swap(img, src, ss, alt, token) {
    // Preload with the SAME srcset/sizes so the browser fetches the exact
    // candidate the <img> will pick (not a second, differently sized file).
    var pre = new Image();
    pre.onload = pre.onerror = function() {
      if (img.getAttribute('data-fc-swap-token') !== token) return;   // superseded
      img.classList.add('is-swapping');
      setTimeout(function() {
        if (img.getAttribute('data-fc-swap-token') !== token) return;
        if (ss) img.setAttribute('srcset', ss); else img.removeAttribute('srcset');
        img.setAttribute('src', src);
        if (alt != null) img.setAttribute('alt', alt);
        requestAnimationFrame(function() { img.classList.remove('is-swapping'); });
      }, 180);
    };
    if (ss) { pre.sizes = img.getAttribute('sizes') || '(max-width: 900px) 100vw, 55vw'; pre.srcset = ss; }
    pre.src = src;
  }

  // Model + colour sets (2026-10-29, lens protector): keys "Colour|<Model>"; a model
  // with no photos of the colour (and no variant photo) falls back to the colour's
  // device-family key, then to the bare colour key. null = keep what is showing.
  function resolveKey(key) {
    var l = cfg.lists[key];
    if (l && l.length) return key;
    if (cfg.modelSets) {
      var parts = String(key).split('|');
      var fam = /iphone/i.test(parts[1] || '') ? 'iphone' : 'galaxy';
      var fk = parts[0] + '|' + fam;
      if (cfg.lists[fk] && cfg.lists[fk].length) return fk;
      if (cfg.lists[parts[0]] && cfg.lists[parts[0]].length) return parts[0];
      return null;
    }
    return l ? key : null;
  }
  function apply(wanted) {
    var color = resolveKey(wanted);
    if (!color) return;           // colour with no classified images: keep what is showing
    if (color === current) return;
    var list = cfg.lists[color];
    // Device family of the wanted / showing set ("Black|iphone" keys, 2026-09-11).
    // The key's suffix is the device family ("Black|iphone") or, with model sets, the
    // Model value ("Black|iPhone Duo"); the family is derived from either.
    var sufNow = String(color).split('|')[1] || '';
    var sufWas = String(current || '').split('|')[1] || '';
    var devNow = sufNow ? (/iphone/i.test(sufNow) ? 'iphone' : 'galaxy') : '';
    var familyChange = !!((cfg.devices || cfg.modelSets) && sufNow && sufWas && sufNow !== sufWas);
    imgs.forEach(function(img) {
      var slot = parseInt(img.getAttribute('data-fc-story-img'), 10) || 0;
      var want = (cfg.start || 1) - 1 + slot;
      // Per-scene photo pick for the iPhone Duo set (2026-10-23, Sentinel H1: scene 3 is
      // the 360° ring kickstand, the 7th Duo photo, not the cover close-up at its slot).
      var pick = parseInt(img.getAttribute('data-fc-story-pick-iphone'), 10) || 0;
      if (devNow === 'iphone' && pick > 0 && list[pick - 1]) want = pick - 1;
      var item = list[want];
      // iPhone Duo with fewer Duo shots than scenes (2026-10-23, owner: a Duo
      // variant still showed Galaxy Z Fold photos): repeat the Duo set rather
      // than falling back to the scene's uploaded (Galaxy) image.
      if (!item && devNow === 'iphone' && list.length) item = list[want % list.length];
      var src, ss = '', alt = null;
      if (item) { src = item.s; ss = item.ss || ''; alt = item.a || img.getAttribute('data-fc-alt-fallback') || ''; }
      else { src = img.getAttribute('data-fc-fallback'); alt = img.getAttribute('data-fc-alt-fallback') || ''; }
      if (!src) return;
      // New token FIRST: it cancels any still-loading swap for this slot even
      // when the wanted file is already on screen (otherwise a slow earlier
      // swap could land after this one and show the wrong colour).
      var token = String(++pending);
      img.setAttribute('data-fc-swap-token', token);
      img.classList.remove('is-swapping');
      if (img.getAttribute('src') === src) return;
      // A family change hides the other device's photo at once instead of
      // leaving it on screen until the new file has loaded.
      if (familyChange) img.classList.add('is-swapping');
      swap(img, src, ss, alt, token);
    });
    current = color;
  }

  document.addEventListener('fc:variant:change', function(e) {
    var d = e && e.detail;
    if (!d || !d.variant || !d.variant.options) return;
    if (d.productId && cfg.productId && String(d.productId) !== String(cfg.productId)) return;
    // Model sets (2026-10-28, Ion Glass): groupIdx is the option that keys the lists (the
    // Model option on a product without a Colour option); colorIdx stays the Colour option
    // or -1, like fc-pp-info's bridge. Older JSON without groupIdx keeps the colour index.
    var gidx = (typeof cfg.groupIdx === 'number' && cfg.groupIdx > -1) ? cfg.groupIdx : cfg.colorIdx;
    var color = d.variant.options[gidx];
    if (color == null) return;
    var key = String(color);
    // Model + colour sets (2026-10-29): "Colour|<Model>", resolved by apply().
    if (cfg.modelSets && typeof cfg.modelIdx === 'number' && cfg.modelIdx > -1 && d.variant.options[cfg.modelIdx] != null) {
      key += '|' + String(d.variant.options[cfg.modelIdx]);
    } else
    // Device-family split (2026-09-11): lists are keyed "Colour|galaxy" /
    // "Colour|iphone" when the product carries iPhone Duo media.
    if (cfg.devices && typeof cfg.modelIdx === 'number' && cfg.modelIdx > -1) {
      var mv = d.variant.options[cfg.modelIdx];
      key += '|' + (/iphone/i.test(String(mv || '')) ? 'iphone' : 'galaxy');
    }
    apply(key);
  });
  // Landing resync: follow the buy box's real variant when the first paint differs.
  var landing = fcStoryLanding(root);
  if (landing && landing.k && landing.k !== current) apply(landing.k);
  }
  function initDeviceSwitch(root) {

  var midx = parseInt(root.getAttribute('data-fc-midx'), 10); if (isNaN(midx)) midx = -1;
  var pid = root.getAttribute('data-fc-pid');
  if (midx < 0) return;
  var phones = Array.prototype.slice.call(root.querySelectorAll('[data-fc-story-phone]'));
  // Intro copy per family (2026-10-23): heading / subheading carry
  // data-fc-story-copy="galaxy|iphone"; the iPhone pair exists only when the
  // section has iPhone copy and the product an iPhone Duo model.
  var copies = Array.prototype.slice.call(root.querySelectorAll('[data-fc-story-copy]'));
  var hasIphoneCopy = copies.some(function(el) { return el.getAttribute('data-fc-story-copy') === 'iphone'; });
  document.addEventListener('fc:variant:change', function(e) {
    var d = e && e.detail;
    if (!d || !d.variant || !d.variant.options) return;
    if (d.productId && pid && String(d.productId) !== String(pid)) return;
    var mval = d.variant.options[midx];
    if (mval == null) return;
    setDevice(/iphone/i.test(String(mval)) ? 'iphone' : 'galaxy');
  });
  function setDevice(dev) {
    phones.forEach(function(p) { p.setAttribute('data-fc-device', dev); });
    if (hasIphoneCopy) copies.forEach(function(el) { el.hidden = el.getAttribute('data-fc-story-copy') !== dev; });
  }
  // Landing resync (2026-10-24): the outline and the copy follow the buy box's real variant.
  var landing = fcStoryLanding(root);
  if (landing && landing.d) setDevice(landing.d);
  }
  function initScenes(root) {

  var scenes = Array.prototype.slice.call(root.querySelectorAll('[data-fc-scene]'));
  if (!scenes.length) return;

  var phones = Array.prototype.slice.call(root.querySelectorAll('[data-fc-story-phone]'));
  var floatingPhones = phones.filter(function(p) { return !p.classList.contains('fc-story__phone--mobilebar'); });
  var mobileBar = root.querySelector('[data-fc-mobile-bar]');
  var mobileTexts = Array.prototype.slice.call(root.querySelectorAll('[data-fc-mobile-text]'));
  var activeScenes = new Set();

  function setActiveScene(idx) {
    phones.forEach(function(p) { p.setAttribute('data-scene', String(idx)); });
    mobileTexts.forEach(function(t) {
      t.classList.toggle('is-active', parseInt(t.getAttribute('data-fc-mobile-text'), 10) === idx);
    });
  }

  function chooseMostVisible() {
    if (!activeScenes.size) return;
    var vh = window.innerHeight;
    var center = vh / 2;
    var best = null;
    var bestDist = Infinity;
    activeScenes.forEach(function(el) {
      var r = el.getBoundingClientRect();
      var d = Math.abs((r.top + r.height / 2) - center);
      if (d < bestDist) { bestDist = d; best = el; }
    });
    if (best) setActiveScene(parseInt(best.getAttribute('data-fc-scene'), 10) || 0);
  }

  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          activeScenes.add(entry.target);
        } else {
          entry.target.classList.remove('is-visible');
          activeScenes.delete(entry.target);
        }
      });
      var isActive = activeScenes.size > 0;
      phones.forEach(function(p) { p.classList.toggle('is-active', isActive); });
      chooseMostVisible();
    }, { threshold: 0.35, rootMargin: '0px 0px -15% 0px' });
    scenes.forEach(function(s) { revealObserver.observe(s); });

    function getPhoneBottom() {
      var w = window.innerWidth;
      if (w <= 900) return 20;
      if (w <= 1200) return 110;
      return 120;
    }
    function updateAnchors() {
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight;
      var base = getPhoneBottom();
      floatingPhones.forEach(function(p) {
        var bottom = Math.max(base, vh - rect.bottom + base);
        p.style.bottom = bottom + 'px';
      });
    }
    window.addEventListener('scroll', function() {
      if (activeScenes.size) chooseMostVisible();
      updateAnchors();
    }, { passive: true });
    window.addEventListener('resize', updateAnchors);
    updateAnchors();
  } else {
    scenes.forEach(function(s) { s.classList.add('is-visible'); });
    phones.forEach(function(p) { p.classList.add('is-active'); });
    setActiveScene(scenes.length - 1);
  }

  // --------------------------------------------------------------------------
  // Auto-slide snap — wheel (desktop) + touch swipe (mobile).
  //
  // Any small scroll inside the section advances to the next scene's top. At
  // the first/last scene, we return `null` from findNextTop and don't call
  // preventDefault, so the user's natural scroll passes through and exits the
  // section (no trap). Outside the section there's no intercept at all.
  // --------------------------------------------------------------------------
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var snapLockUntil = 0;
  var SNAP_LOCK_DURATION = 850;

  function getSceneTops() {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    return scenes.map(function(s) {
      return s.getBoundingClientRect().top + scrollY;
    });
  }

  function snapTo(y) {
    snapLockUntil = Date.now() + SNAP_LOCK_DURATION;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  // Next scene top past the current scroll position (direction: +1 down / -1 up).
  // Returns null when there is no further scene in that direction → caller lets
  // the native scroll proceed so the user can exit the section.
  function findNextTop(direction, scrollY) {
    var sceneTops = getSceneTops();
    if (direction > 0) {
      for (var i = 0; i < sceneTops.length; i++) {
        if (sceneTops[i] > scrollY + 40) return sceneTops[i];
      }
    } else {
      for (var j = sceneTops.length - 1; j >= 0; j--) {
        if (sceneTops[j] < scrollY - 40) return sceneTops[j];
      }
    }
    return null;
  }

  // Only intercept scroll when the section is dominating the viewport.
  function shouldIntercept() {
    var rect = root.getBoundingClientRect();
    var vh = window.innerHeight;
    return rect.top < vh * 0.5 && rect.bottom > vh * 0.5;
  }

  // --- Desktop: wheel ---
  window.addEventListener('wheel', function(e) {
    var now = Date.now();
    if (now < snapLockUntil) {
      e.preventDefault();
      return;
    }
    if (!shouldIntercept()) return;

    var direction = e.deltaY > 0 ? 1 : -1;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    var target = findNextTop(direction, scrollY);
    // No more scenes in this direction — let the page scroll out naturally.
    if (target === null) return;

    e.preventDefault();
    snapTo(target);
  }, { passive: false });

  // --- Mobile: touch swipe ---
  // Intercept the touch mid-gesture so the native scroll doesn't fight the snap.
  var touchStartY = 0;
  var touchStartTime = 0;
  var touchInSection = false;
  var touchIntercepted = false;

  window.addEventListener('touchstart', function(e) {
    touchStartY = e.touches[0].clientY;
    touchStartTime = Date.now();
    touchInSection = shouldIntercept();
    touchIntercepted = false;
  }, { passive: true });

  window.addEventListener('touchmove', function(e) {
    if (!touchInSection) return;
    if (Date.now() < snapLockUntil) { e.preventDefault(); return; }

    var deltaY = touchStartY - e.touches[0].clientY;
    if (Math.abs(deltaY) < 18) return;

    // Only block native scroll if there is a next scene to go to. At the ends,
    // let the fling pass through so the user can exit.
    var direction = deltaY > 0 ? 1 : -1;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    var target = findNextTop(direction, scrollY);
    if (target !== null) {
      e.preventDefault();
      touchIntercepted = true;
    }
  }, { passive: false });

  window.addEventListener('touchend', function(e) {
    if (!touchInSection || !touchIntercepted) return;
    if (Date.now() < snapLockUntil) return;

    var touchEndY = e.changedTouches[0].clientY;
    var deltaY = touchStartY - touchEndY;
    var deltaTime = Date.now() - touchStartTime;

    // Ignore taps / super slow drags.
    if (Math.abs(deltaY) < 30 || deltaTime > 900) return;

    var direction = deltaY > 0 ? 1 : -1;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    var target = findNextTop(direction, scrollY);
    if (target === null) return;

    snapTo(target);
  }, { passive: true });
  }
  function init() {
    var root = document.getElementById('fc-pp-story');
    if (!root || root.getAttribute('data-fc-init') === '1') return;
    root.setAttribute('data-fc-init', '1');
    initColorSets(root);
    initDeviceSwitch(root);
    initScenes(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fc-pp-story')) init();
  });
})();
